export const REPORTER_CATEGORIES = {
    corporation: 'family_to_accept_reporter_corporation',
    private: 'family_to_accept_reporter_private',
    welfare: 'family_to_accept_reporter_welfare'
};
